import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";

const Section = ({ title, count, ids = [] }) => (
	<Box>
		<Typography variant="subtitle2" fontWeight={700}>
			{title}: {count}
		</Typography>
		{ids?.length > 0 && (
			<Typography
				variant="body2"
				color="text.secondary"
				sx={{ mt: 0.5, maxHeight: 120, overflow: "auto", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
				{ids.join(", ")}
			</Typography>
		)}
	</Box>
);

const UploadResultModal = ({ modal, setModal, result }) => {
	const handleClose = () => setModal(false);

	const processed = result?.processed ?? 0;
	const updated = result?.updated ?? 0;
	const skipped = result?.skipped_unchanged ?? 0;
	const updatedStyles = result?.updated_style_ids?.length ?? 0;

	return (
		<Dialog open={modal} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<Typography variant="h6">Bulk Sourcing Upload Result</Typography>
				<IconButton onClick={handleClose}>
					<ClearRounded />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Stack spacing={2}>
					<Typography variant="body1">
						Processed <strong>{processed}</strong> color row(s).
					</Typography>
					<Section title="Updated" count={updated} ids={result?.updated_identifiers} />
					<Section
						title="Skipped (unchanged)"
						count={skipped}
						ids={result?.skipped_unchanged_identifiers}
					/>
					{updatedStyles > 0 && (
						<Section title="Styles with style-level updates" count={updatedStyles} ids={result?.updated_style_ids} />
					)}
					{updated === 0 && skipped > 0 && (
						<Typography variant="body2" color="text.secondary">
							Same values were not rewritten.
						</Typography>
					)}
				</Stack>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button variant="contained" onClick={handleClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default UploadResultModal;
